module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    staticClass: "next"
  }, _vm._l((_vm.block), function(item, index) {
    return _c('div', _vm._l((item), function(e, k2) {
      return _c('b', {
        class: e ? 'active type-' + e : ''
      }, [_vm._v("德")])
    }))
  }))
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-f317c03c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/next/index.vue
// module id = 179
// module chunks = 1